export const setTextFilter = (text = '') => ({
    type: 'SET_TEXT_FILTER',
    text,
})

export const setBillableFilter = (billable = '') => ({
    type: 'SET_BILLABLE_FILTER',
    billable,
})